import React, { useEffect, useState } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router'
import SideBar from '../../layout/sidebar'
import Header from '../../layout/header'
import handleGet from '../../utils/Get'
import { BASE_URL } from '../../utils/config'

const Admin = () => {

    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    const [showSiderbar, setShowSiderbar] = useState(false);
    const user = JSON.parse(userData);
    const navigate = useNavigate()

    useEffect(() => {
        if (!token) {
            navigate('/login');
            return;
        }
        else if (user.type === 'user') {
            navigate('/login');
        }
    }, [])

    const [UserNotification, setnotification] = useState("");
    const location = useLocation();
    
      const fetchNotification = async () => {
        try {
          const data = await handleGet(`${BASE_URL}allusers/notifications`);
          setnotification(data?.data);
        } catch (error) {
          console.error("Error fetching notifications:", error);
        }
      };
    
      useEffect(() => {
        // Call immediately on mount
        fetchNotification();
    
        // Set up interval to call every 1 minute (60,000 milliseconds)
        const intervalId = setInterval(fetchNotification, 1800000);
    
        // Cleanup interval on component unmount
        return () => clearInterval(intervalId);
      }, []);

      useEffect(() => {
        fetchNotification();
    }, [location.pathname]);


    return (token && (user.type === 'admin' || user?.type === 'agent') &&
        <div className='grid grid-cols-4 bg-admin dark:bg-dark-body h-fit min-h-screen' >
            <aside className={`${showSiderbar ? 'translate-x-0' : '-translate-x-full'} fixed xl:translate-x-0 w-72 z-10 h-[100vh] overflow-hidden transition-all duration-500`}>
                <SideBar setShowSiderbar={setShowSiderbar} />
            </aside>
            <main className='col-span-4 xl:ml-[288px] ml-0 transition-all duration-500 p-8 md:px-12 overflow-x-hidden overflow-y-auto'>
                <section className='w-full h-16 items-center flex mb-5'>
                    <Header setShowSiderbar={setShowSiderbar} UserNotification={UserNotification} fetchNotification={fetchNotification}/>
                </section>
                <section>
                    <Outlet />
                </section>
            </main>
        </div>
    )
}

export default Admin